export default {
  noData: 'Pre aktuálne kritériá filtrovania sa nenašli žiadne udalosti.',
};
